// extracted by mini-css-extract-plugin
export default {"container":"_M-z","topReviewHeading":"aN-z","criticalReview":"bN-z","favorableReview":"cN-z","vsSeparator":"dN-z"};